"use strict";

exports.__esModule = true;
exports.yesterday = exports.twoYearsAgo = exports.tomorrow = exports.today = exports.threeMonthsAgo = exports.sixMonthsAgo = exports.oneYearAgo = exports.oneWeekAgo = exports.oneMonthAgo = exports.nextWeek = exports.nextThreeMonths = exports.nextSixMonths = exports.nextMonth = exports.makeDate = void 0;
var _luxon = require("luxon");
// These functions are take from blueprintjs as they already implemented dateranges

var today = exports.today = new Date();
var clone = function clone(d) {
  return new Date(d.getTime());
};
var makeDate = exports.makeDate = function makeDate(action, date) {
  if (date === void 0) {
    date = today;
  }
  var returnVal = clone(date);
  action(returnVal);
  returnVal.setDate(returnVal.getDate() + 1);
  returnVal.setHours(0);
  returnVal.setMinutes(0);
  returnVal.setSeconds(0);
  returnVal.setMilliseconds(0);
  returnVal.setHours(returnVal.getHours() + addDSTDifference(date, returnVal));
  return returnVal;
};
var addDSTDifference = function addDSTDifference(today, calculated) {
  var isTodayDST = _luxon.DateTime.fromMillis(today.getTime()).isInDST;
  var isCalculatedDST = _luxon.DateTime.fromMillis(calculated.getTime()).isInDST;
  if (isTodayDST === isCalculatedDST) return 0;
  return isTodayDST && !isCalculatedDST ? -1 : 1;
};
var nextSixMonths = exports.nextSixMonths = makeDate(function (d) {
  return d.setMonth(d.getMonth() + 6);
});
var nextThreeMonths = exports.nextThreeMonths = makeDate(function (d) {
  return d.setMonth(d.getMonth() + 3);
});
var nextMonth = exports.nextMonth = makeDate(function (d) {
  return d.setMonth(d.getMonth() + 1);
});
var nextWeek = exports.nextWeek = makeDate(function (d) {
  return d.setDate(d.getDate() + 5);
});
var tomorrow = exports.tomorrow = makeDate(function (d) {
  return d.setDate(d.getDate());
});
var yesterday = exports.yesterday = makeDate(function (d) {
  return d.setDate(d.getDate() - 2);
});
var oneWeekAgo = exports.oneWeekAgo = makeDate(function (d) {
  return d.setDate(d.getDate() - 7);
});
var oneMonthAgo = exports.oneMonthAgo = makeDate(function (d) {
  return d.setMonth(d.getMonth() - 1);
});
var threeMonthsAgo = exports.threeMonthsAgo = makeDate(function (d) {
  return d.setMonth(d.getMonth() - 3);
});
var sixMonthsAgo = exports.sixMonthsAgo = makeDate(function (d) {
  return d.setMonth(d.getMonth() - 6);
});
var oneYearAgo = exports.oneYearAgo = makeDate(function (d) {
  return d.setFullYear(d.getFullYear() - 1);
});
var twoYearsAgo = exports.twoYearsAgo = makeDate(function (d) {
  return d.setFullYear(d.getFullYear() - 2);
});